// extracted by mini-css-extract-plugin
export default {"form":"form___N08ik","logo":"logo___Uj676","header":"header___rjtlc","links":"links___aCIQP","terms":"terms___QRdhM"};